import { useCallback, useState } from 'react';

import { DuplicateRideModal } from './DuplicateRideModal';

const INITIAL_STATE = {
  visible: false,
  riderName: '',
  duplicates: [],
  isRecurring: false,
  isRoundtrip: false,
};

export const useDuplicateRideModal = ({ onContinue } = {}) => {
  const [state, setState] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(false);

  const open = useCallback((payload = {}) => {
    setState({
      visible: true,
      riderName: payload.riderName || '',
      duplicates: payload.duplicates || [],
      isRecurring: !!payload.isRecurring,
      isRoundtrip: !!payload.isRoundtrip,
    });
  }, []);

  const close = useCallback(() => {
    setLoading(false);
    setState(INITIAL_STATE);
  }, []);

  const handleContinue = useCallback(async () => {
    if (!onContinue) {
      close();
      return;
    }
    try {
      setLoading(true);
      await onContinue();
      close();
    } catch {
      setLoading(false);
    }
  }, [onContinue, close]);

  return {
    DuplicateRideModal: (
      <DuplicateRideModal
        visible={state.visible}
        riderName={state.riderName}
        duplicates={state.duplicates}
        isRecurring={state.isRecurring}
        isRoundtrip={state.isRoundtrip}
        loading={loading}
        onCancel={close}
        onContinue={handleContinue}
      />
    ),
    openDuplicateRideModal: open,
  };
};
